import React, { useEffect, useRef } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEntity, deleteEntity } from './tire-tread-model.reducer';

export const TireTreadModelDeleteDialog = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();
  const hasDeleted = useRef(false);

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const tireTreadModelEntity = useAppSelector(state => state.tireTreadModel.entity);
  const updateSuccess = useAppSelector(state => state.tireTreadModel.updateSuccess);

  const handleClose = () => {
    props.history.push('/tire-tread-model' + props.location.search);
  };

  useEffect(() => {
    if (updateSuccess && hasDeleted.current) {
      handleClose();
    }
  }, [updateSuccess]);

  const confirmDelete = () => {
    hasDeleted.current = true;
    dispatch(deleteEntity(tireTreadModelEntity.id));
  };

  return (
    <Modal isOpen toggle={handleClose}>
      <ModalHeader toggle={handleClose} data-cy="tireTreadModelDeleteDialogHeading">
        <Translate contentKey="entity.delete.title">Confirm delete operation</Translate>
      </ModalHeader>
      <ModalBody id="fleetSenseApp.tireTreadModel.delete.question">
        <Translate contentKey="fleetSenseApp.tireTreadModel.delete.question" interpolate={{ id: tireTreadModelEntity.name }}>
          Are you sure you want to delete this TireTreadModel?
        </Translate>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleClose}>
          <FontAwesomeIcon icon="ban" />
          &nbsp;
          <Translate contentKey="entity.action.cancel">Cancel</Translate>
        </Button>
        <Button id="app-confirm-delete-tireTreadModel" data-cy="entityConfirmDeleteButton" color="danger" onClick={confirmDelete}>
          <FontAwesomeIcon icon="trash" />
          &nbsp;
          <Translate contentKey="entity.action.delete">Delete</Translate>
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default TireTreadModelDeleteDialog;
